module.exports = __webpack_public_path__ + "static/img/3-3.fc4804d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/3-3.png
// module id = 2dhy
// module chunks = 1